/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'
const ServiceBox = ({ serviceName }) => (
    <div className="col-lg-4">
        <div className="box wow fadeInLeft">
            <div className="icon"><i className="fa fa-shopping-bag"></i></div>
            <h4 className="title"><a href="#">{serviceName}</a></h4>
            <p className="description"></p>
        </div>
    </div>
);



const Section = ({ id, header, children }) => (
    <section id={id} className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
        <div className="container">
            <div className="section-header">
                <h2>{header}</h2>
            </div>
            <div className="row">
                {children}
            </div>
        </div>
    </section>
);



const App = () => {
    const [qs, setQs] = useState("");

    // Decrypting the query string on load (this will be specific to your app logic)
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const encryptedValue = urlParams.get("an");

        if (encryptedValue) {
            const decryptedValue = decrypt(encryptedValue); // You need to define your decrypt function
            setQs(decryptedValue);
        }
    }, []);

    useEffect(() => {
        if (qs.length > 2) {
            visit(qs); // Replace with appropriate action
        }
    }, [qs]);

    const decrypt = (value) => {
        // Implement your decryption logic here
        return value; // Placeholder for decryption
    };

    const visit = (qs) => {
        // Handle what happens when qs is set
        console.log(`Visiting: ${qs}`);
    };
    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <>
            <MasterPage state={state}>
        <div>
            <section id="intro">
                <div className="intro-content">
                    <h2><span>Manage</span><br />Business With Tejaxo BI Embedded ERP</h2>
                    <div>
                        <a href="#about" className="btn-get-started scrollto">Get Started</a>
                    </div>
                </div>
                <div className="item" style={{ backgroundImage: 'url("../../theme/img/intro-carousel/1.jpg")' }}></div>
            </section>

            <main id="main">
                <Section id="about" header="Innovating to simplify business management">
                    <div className="col-lg-6 about-img">
                        <img src="../../theme/img/about-img.png" alt="" />
                    </div>
                    <div className="col-lg-6 content">
                        <p>
                            We are an Indian developer of award-winning business management and analytics solutions.
                            <a href="/products/tejaxo-erp/" target="_blank" rel="noopener">Tejaxo ERP</a>,
                            integrates accounting, operational and mobile features in a single system � optimising business processes.
                        </p>
                        <p>
                            With headquarters and a Development Centre located in India, we have a global network of <a href="/about-Tejaxo/global-offices/" target="_blank" rel="noopener">Resellers</a>
                            and <a href="https://www.tejaxo.com/about-Tejaxo-software/partners/" target="_blank" rel="noopener">Solution Partners</a>.
                        </p>
                    </div>
                </Section>

                <section id="services">
                    <div className="container">
                        <div className="section-header">
                            <h2>Powerful functionality to manage complex demands</h2>
                        </div>
                        <div className="row">
                            {["Financials", "Distribution", "CRM", "Supply Chain", "Asset Facility Management", "Manufacturing", "Business Intelligence Applications", "Business Intelligence Visualizations", "Business Intelligence Data"].map((service, index) => (
                                <ServiceBox key={index} serviceName={service} />
                            ))}
                        </div>
                    </div>
                </section>

                <Section id="about" header="Our Esteemed Projects and Clients">
                    <div className="col-lg-4 content">
                        <p>
                            Our software works in different industry verticals like Business Intelligence (BI), RPA (Robotic Process Automation), Factory Automation, and Business Management.
                        </p>
                    </div>
                    <div className="col-lg-8 about-img">
                        <img src="../../theme/img/customers.png" alt="" />
                    </div>
                </Section>

                <Section id="about" header="Tejaxo ERP & Analytics efficiency & insights">
                    <div className="col-lg-6 content">
                        <p>
                            We help you synchronize your best business processes so everyone across your organization collaborates and creates a fluid system.
                        </p>
                    </div>
                    <div className="col-lg-6 about-img">
                        <img src="../../theme/img/about-img.png" alt="" />
                    </div>
                </Section>

                <Section id="services" header="Product Delivery Steps">
                    <div className="row">
                        {["Marketing", "Consulting", "Strategy", "Quality", "Analysis", "Delivery"].map((step, index) => (
                            <ServiceBox key={index} serviceName={step} />
                        ))}
                    </div>
                </Section>
            </main>
                </div>
            </MasterPage>

        </>
    );
};

export default App;
